import React, { Component } from 'react';
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as operations from './operations';

import { connectedSelectField } from 'app/components/form/field/select';

function groupsSelectImplementation ( WrappedComponent ) {
    return class extends Component {

        onSearchEvent = ( searchQuery ) => {
            const { search } = this.props;
            return search({
                refs: 0,
                query: {
                    name: `${searchQuery}*`
                }
            }, false);
        };

        map = ( group ) => ({ key: group.id, value: group.id, label: group.name });

        render( ) {
            const { select, ...rest } = this.props;
            const default_select = {
                map: this.map,
                multiple: true,
                onSearchEvent: this.onSearchEvent,
                ...select
            };

            return <WrappedComponent
                        placeholder='Search groups by name ...'
                        select={default_select}
                        {...rest}
                    />;
        }
    };
}

const mapDispatchToProps =  ( dispatch, ownProps ) => {
    const { blrfKey = 'groups_select' } = ownProps;
    return bindActionCreators(
        {
            search: (query) => operations.search(blrfKey, query),
        }, dispatch);
};

const mapStateToProps = ( state, ownProps ) => {
    const { blrfKey = 'groups_select' } = ownProps;
    const { loading = false, error = false, query = { refs: 0, page: 1 }, data = []} = state.app.blrf.objects[blrfKey] || state.app.blrf.defaultObject;
    return {
        loading, 
        query, 
        data,
        error: (error !== false ? error && error.message : false)
    }
};

const groupsSelectField = connect(mapStateToProps, mapDispatchToProps)(groupsSelectImplementation(connectedSelectField()));

export {
    groupsSelectField
};
